import type { FC } from 'react';

import type { ModalComponent } from '../../types';

import { BlocksList, Markdown, Typo } from '@snowit/ui';

import Modal from '../Modal/Modal';

import s from './ModalError.module.scss';

const ModalError: FC<ModalComponent> = (props: ModalComponent) => {
  const { code, body, size = 'df' } = props;

  const renderBodyContent = () => {
    const bodyContent = typeof body === 'function' ? body() : body || '';

    if (typeof bodyContent === 'string') {
      return <Markdown source={bodyContent} />;
    }

    return bodyContent;
  };

  const renderErrorCode = () => {
    if (!code) return null;

    return (
      <div className={s.code}>
        <Typo
          text={code}
          tag={'p'}
          family={'mono'}
          size={'md'}
          weight={'semi-bold'}
          color={'text'}
        />
      </div>
    );
  };

  const renderBody = () => {
    return (
      <BlocksList>
        {renderBodyContent()}
        {renderErrorCode()}
      </BlocksList>
    );
  };

  return (
    <Modal
      {...props}
      classNames={{
        ...props.classNames,
        headerContent: s.headerContent,
      }}
      body={renderBody}
      theme={'error'}
      size={size}
    />
  );
};

export default ModalError;
